import React from "react";
import { InventoryInFormModal } from "../InventoryInFormModal";

export function ExcessReturnFromCustomerModal({ open, onOpenChange, onSuccess }) {
  return (
    <InventoryInFormModal
      open={open}
      onOpenChange={onOpenChange}
      onSuccess={onSuccess}
      sourceType="Excess_Return_From_Customer"
      labelKey="inventory.excessReturnFromCustomer"
    />
  );
}
